module.exports = __webpack_public_path__ + "img/news-header.7734f7af.png";